export default "__VITE_ASSET__Ca50MBIs__"